/** Filesystem-safe ISO timestamp for PDF download names. */
export function formatTimestampForPdfFilename(date: Date = new Date()): string {
  return date.toISOString().replace(/[:.]/g, '-')
}

export function buildRiskAssessmentPdfFilename(date: Date = new Date()): string {
  return `risk-assessment-${formatTimestampForPdfFilename(date)}.pdf`
}

export function buildInstructionHandbookPdfFilename(
  date: Date = new Date()
): string {
  return `manual-${formatTimestampForPdfFilename(date)}.pdf`
}
